// src/router/sidebar.js
export const sidebarMenu = {
  Admin: [
    {
      icon: "home",
      tileName: "Home",
      link: "/",
    },
    {
      icon: "category",
      tileName: "Category",
      link: "/category",
    },
    {
      icon: "menu_book",
      tileName: "Welcome",
      link: "/welcome",
    },
    // {
    //   icon: "mdi-frequently-asked-questions",
    //   tileName: "FAQ",
    //   link: "/psct/faq",
    // },
    {
      icon: "admin_panel_settings",
      tileName: "Admin",
      subtiles: [
        {
          icon: "mdi-animation-outline",
          subTileName: "Buying Group",
          appFolderName: "",
          defaultLink: "/buying-group",
          isUrl: false,
        },
        {
          icon: "mdi-notebook-multiple",
          subTileName: "Region And Plants",
          appFolderName: "",
          defaultLink: "/regionandplants",
          isUrl: false,
        },

        {
          icon: "mdi-bell-ring",
          subTileName: "Updates To Strategy",
          appFolderName: "",
          defaultLink: "/updatestostrategy",
          isUrl: false,
        },

        {
          icon: "mdi-link-box",
          subTileName: "Quick Links",
          appFolderName: "",
          defaultLink: "/quicklinks",
          isUrl: false,
        },
      ],
    },
    {
      icon: "outbox",
      tileName: "CM Form Submission",
      subtiles: [
        {
          icon: "mdi-view-grid-plus",
          subTileName: "Category Submission",
          appFolderName: "",
          defaultLink: "/categorysubmission",
          isUrl: false,
        },
        {
          icon: "mdi-content-save-settings",
          subTileName: "Commodity Submission",
          appFolderName: "",
          defaultLink: "/commoditysubmission",
          isUrl: false,
        },
        {
          icon: "mdi-wallet-plus",
          subTileName: "Segment Submission",
          appFolderName: "",
          defaultLink: "/segmentsubmission",
          isUrl: false,
        },
      ],
    },
    {
      icon: "inbox",
      tileName: "Request History",
      subtiles: [
        {
          icon: "mdi-view-grid-plus",
          subTileName: "Category History",
          appFolderName: "",
          defaultLink: "/categorylog",
          isUrl: false,
        },
        {
          icon: "mdi-content-save-settings",
          subTileName: "Commodity History",
          appFolderName: "",
          defaultLink: "/commoditylog",
          isUrl: false,
        },
        {
          icon: "mdi-wallet-plus",
          subTileName: "Segment History",
          appFolderName: "",
          defaultLink: "/segmentlog",
          isUrl: false,
        },
      ],
    },
  ],
  CMUsers: [
    {
      icon: "home",
      tileName: "Home",
      link: "/",
    },
    {
      icon: "category",
      tileName: "Category",
      link: "/category",
    },
    {
      icon: "menu_book",
      tileName: "Welcome",
      link: "/welcome",
    },
    // {
    //   icon: "mdi-frequently-asked-questions",
    //   tileName: "FAQ",
    //   link: "/psct/faq",
    // },

    {
      icon: "outbox",
      tileName: "Form Requests",
      subtiles: [
        {
          icon: "mdi-view-grid-plus",
          subTileName: "Category Requests",
          appFolderName: "",
          defaultLink: "/categoryrequests",
          isUrl: false,
        },
        {
          icon: "mdi-content-save-settings",
          subTileName: "Commodity Requests",
          appFolderName: "",
          defaultLink: "/commodityrequests",
          isUrl: false,
        },
        {
          icon: "mdi-wallet-plus",
          subTileName: "Segment Requests",
          appFolderName: "",
          defaultLink: "/segmentrequests",
          isUrl: false,
        },
      ],
    },
  ],
  AllUsers: [
    {
      icon: "home ",
      tileName: "Home",
      link: "/",
    },
    {
      icon: "category",
      tileName: "Category",
      link: "/category",
    },
    {
      icon: "menu_book",
      tileName: "Welcome",
      link: "/welcome",
    },
    // {
    //   icon: "mdi-frequently-asked-questions",
    //   tileName: "FAQ",
    //   link: "/psct/faq",
    // },
  ],
};
